import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberVerticalToward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronGrabberVerticalToward"><Path d="M17.4141 18.75L16 20.1641L12 16.1641L8 20.1641L6.58594 18.75L12 13.3359L17.4141 18.75Z" fill="currentColor"/><Path d="M17.4141 5.25L12 10.6641L6.58594 5.25L8 3.83594L12 7.83594L16 3.83594L17.4141 5.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronGrabberVerticalToward;
